import React from 'react';
import styled, { css } from 'styled-components';
import theme from 'theme';

import { LogoIcon } from 'components/icons/LogoIcon';

type Props = {
  isMobile?: boolean;
};

const Footer = ({ isMobile = false }: Props) => {
  return (
    <Container $isMobile={isMobile}>
      <LogoIcon width={70} height={44} fill={theme.colors.white} />
    </Container>
  );
};

const Container = styled.footer<{ $isMobile: boolean }>`
  background-color: ${({ theme }) => theme.colors.topicBlue};
  display: flex;
  justify-content: center;
  padding: 78px 0 200px;
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      padding: 34px 0 100px;
    `}
`;

export default Footer;
